import {DataType} from "@flowmaps/flowmaps-typescriptmodels";
import lodash from "lodash";
import {EnergyLabels} from "../../common/energy-label/energy-label.component";

export class EnergyCompassUtils {
    static labels = Object.values(EnergyLabels).filter((v) => isNaN(Number(v)));

    static getValueWithFactor(measurementType: DataType, values: number[]): number {
        switch (measurementType) {
            case DataType.electricityConsumption:
            case DataType.electricityConsumptionOffPeak:
                return lodash.sum(values);
            case DataType.gasConsumption:
                return lodash.sum(values) * 9.77;
            case DataType.heatConsumption:
                return (lodash.sum(values) * 278) * 0.33;
            case DataType.electricityFeedIn:
            case DataType.electricityFeedInOffPeak:
                return -(lodash.sum(values));
            default:
                return 0;
        }
    }
}